import React, { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  selectAuthStateKnown,
  selectIsAuthenticated,
} from '../../store/slices/userSlice'

interface Props {
  children: React.ReactNode
  enforceAuth: boolean
}

const AuthChecker = ({ children, enforceAuth }: Props) => {
  const navigate = useNavigate()

  const isAuthStateKnown = useSelector(selectAuthStateKnown)
  const isAuthenticated = useSelector(selectIsAuthenticated)

  const location = useLocation()
  const locationRef = useRef(location)

  const isAuthRoute =
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/sign-up')

  useEffect(() => {
    if (enforceAuth && isAuthStateKnown && !isAuthenticated) {
      const from = locationRef.current.pathname
      if (from !== '/login') {
        navigate('/login?from=' + encodeURIComponent(from))
      }
    }
  }, [enforceAuth, isAuthenticated, isAuthStateKnown]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isAuthRoute && isAuthenticated) {
      const timeoutId = setTimeout(() => {
        navigate('/')
      }, 500)
      return () => clearTimeout(timeoutId)
    }
  }, [isAuthRoute, isAuthenticated]) // eslint-disable-line react-hooks/exhaustive-deps

  return <>{children}</>
}

export default AuthChecker
